<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="studiesForm">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="institucion"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Institución o escuela <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionInicio"
                maxlength="4"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionFin"
                maxlength="4"
                rounded
                filled
                dense
                background-color="transparent"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de finalización <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="estatusEstudios"
                item-value="id"
                item-text="title"
                v-model="estatusEstudiosElegido"
                :rules="required"
              >
                <template v-slot:label>Estatus de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="tipoEstudios"
                item-value="id"
                item-text="title"
                v-model="tipoEstudioElegido"
                :rules="required"
              >
                <template v-slot:label>Tipo de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="transparent"
                color="secondary"
                rounded
                filled
                dense
                :items="comprobanteEstudios"
                item-value="id"
                item-text="title"
                v-model="comprobanteEstudioElegido"
                :rules="required"
              >
                <template v-slot:label> Tipo de comprobante de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                no-resize
                rows="4"
                color="secondary"
                background-color="transparent"
                label="Observaciones (Opcional)"
                v-model="observaciones"
                rounded
                filled
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        color="secondary"
        class="primary--text px-8"
        :disabled="!studiesForm || loading"
        :loading="loading"
        @click="triggerSaveStudies()"
      >
        Registrar estudios
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      studiesForm: false,
      loading: false,
      institucion: '',
      generacionInicio: '',
      generacionFin: '',
      observaciones: '',
      comprobanteEstudioElegido: null,
      tipoEstudioElegido: null,
      estatusEstudiosElegido: null,
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  async mounted() {
    await this.fetchComprobantesEstudios()
    await this.fetchEstatusEstudios()
    await this.fetchTipoEstudios()
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),
    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
    }),
  },

  methods: {
    ...mapActions('estudio', ['saveEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async triggerSaveStudies() {
      this.loading = true

      await this.saveEstudiosPersonal({
        fk_idPersonal: this.id,
        institucion: this.institucion,
        generacion: this.generacionInicio + '-' + this.generacionFin,
        observaciones: this.observaciones,
        fk_idCatEstatusEstudio: this.estatusEstudiosElegido,
        fk_idCatEstudio: this.tipoEstudioElegido,
        fk_idComprobanteEstudio: this.comprobanteEstudioElegido,
      })

      await this.fetchEstudiosByPersonal(this.id)
      this.loading = false
      this.$emit('close')
      this.closeDialog()
    },

    closeDialog() {
      this.institucion = ''
      this.generacionInicio = ''
      this.generacionFin = ''
      this.observaciones = ''
      this.comprobanteEstudioElegido = null
      this.tipoEstudioElegido = null
      this.estatusEstudiosElegido = null
      this.loading = false
      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style scoped>
/* Inputs, selects y textarea */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
  caret-color: var(--v-secondary-base) !important;
}

::v-deep input::placeholder,
::v-deep textarea::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Botón de acción */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}
</style>
